import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path:"/",
        redirect:"/home"
    },
    {
    path: '/login',
    name: 'login1',
    component: () => import('../views/login1.vue')
}, {
    path: '/ResetLogin',
    name: 'ResetLogin',
    component: () => import('../views/ResetLogin.vue')
}, {
    path: '/Text',
    name: 'Text',
    component: () => import('../views/Text.vue')
}, {
    path: '/CreateLogin',
    name: 'CreateLogin',
    component: () => import('../views/CreateLogin.vue')
}, {
    path: '/LoginForgot',
    name: 'LoginForgot',
    component: () => import('../views/LoginForgot.vue')
}, {
    path: '/forgetLogin',
    name: 'forgetLogin',
    component: () => import('../views/forgetLogin.vue')
}, {
    path: '/policy',
    name: 'policy',
    component: () => import('../views/policy.vue')
}, {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/mine.vue'),
    children: [{
        path: '',
        redirect: 'index'
    },
    {
        path: 'index',
        component: () => import('../views/mine/index.vue'),
    },
    {
        path: 'collect',
        component: () => import('../views/mine/collect.vue'),
    }
    ]
},
// h5验证
{
    path: '/home/verify/phone',
    name: 'phone',
    component: () => import('../views/home/verify/verify/phone.vue'),
},
{
    path: '/home',
    name: 'home',
    component: () => import('../views/home.vue'),
    children: [{
        path: '',
        redirect: 'index'
    },
    {
        path: 'index',
        component: () => import('../views/home/index/index.vue'),
    },
    {
        path: 'searchResult',
        component: () => import('../views/home/searchResult/searchResult.vue'),
    },
    {
        path: 'goodDetail',
        component: () => import('../views/home/goodDetail/goodDetail.vue'),
    },
    {
        // 营销主页面
        path: 'marketing',
        component: () => import('../views/home/marketing/marketing.vue'),
    },
    {
        //优惠卷
        path: 'coupons',
        component: () => import('../views/home/marketing/coupons.vue'),
    },
    {
        path: 'aboutUs',
        component: () => import('../views/home/aboutUs/aboutUs.vue'),
    },
    {
        // 新增或编辑收货地址
        path: 'Address',
        component: () => import('../views/home/Address/Address.vue'),
    },
    {
        path: 'orderList',
        component: () => import('../views/home/orderList/orderList.vue'),
    },
    {
        path: 'orderConfirm',
        component: () => import('../views/home/orderConfirm/orderConfirm.vue'),
    },
    {
        path: 'car',
        component: () => import('../views/home/car/car.vue'),
    },
    {
        path: 'carsure',
        component: () => import('../views/home/car/carsure.vue'),
    },
    {
        // 新闻主页面
        path: 'news',
        component: () => import('../views/home/news/index.vue'),
    },
    {
        // 品牌 all  Brands
        path: 'Brands',
        component: () => import('../views/home/Brands/Brands.vue'),
    },
    {
        // 品牌 all  Brands   列表页面
        path: 'BrandsLIst',
        component: () => import('../views/home/Brands/BrandsLIst.vue'),
    },
    {
        // 热销   列表页面
        path: 'hotList',
        component: () => import('../views/home/hotList/hotList.vue'),
    },
    {
        // 新闻主页面
        path: 'newsDetial',
        component: () => import('../views/home/news/newsDetial.vue'),
    },
    {
        // 定制主页面
        path: 'customization',
        component: () => import('../views/home/customization/customization.vue'),
    },
    {
        // 定制表单
        path: 'customizationFrom',
        component: () => import('../views/home/customization/customizationFrom.vue'),
    },
    {
        path: 'goodList',
        component: () => import('../views/home/goodList/goodList.vue'),
    },
    {
        path: 'new',
        component: () => import('../views/home/new.vue'),
    }, {
        path: 'inform',
        component: () => import('../views/home/inform.vue'),
    }, {
        path: 'upload',
        component: () => import('../views/home/upload.vue'),
    },
    {
        path: 'beike',
        component: () => import('../views/home/beike.vue'),
    },
    {
        path: 'testPaper',
        component: () => import('../views/home/testPaper.vue'),
    },
    {
        path: 'yuren',
        component: () => import('../views/home/yuren.vue'),
    },
    {
        path: 'newDetail',
        component: () => import('../views/home/newDetail.vue'),
    },
    {
        path: 'noticeDetail',
        component: () => import('../views/home/noticeDetail.vue'),
    },
    {
        path: 'example',
        component: () => import('../views/home/example.vue'),
    },
    {
        path: 'verify',
        component: () => import('../views/home/verify/verify.vue'),
    }
    ]
}
]
const router = new VueRouter({
    routes
})

const whiteUrlArr = [
    '/',
    '/forgetLogin',
    '/policy',
]

router.beforeEach((to, from, next) => {
    // if (localStorage.getItem('TIANYUE_TOKEN')) next()
    // else if (whiteUrlArr.some(url => to.path == url)) next();
    // else {
    //   next('/')
    // }

    // if (to.path == "/home/goodDetail" && !localStorage.getItem("GOOD_INFO")) {
    //     next("/home/index")
    // } else if (to.path === '/home/car' || to.path === '/home/carsure') {
    //     var token = localStorage.getItem("TIANYUE_TOKEN");
    //     if (!token) {
    //         next('/'); // 未登录则跳转到登录页面
    //     } else {
    //         next(); // 已登录则继续跳转
    //     }
    // }
    // else {
    //     next()
    // }
    next()
})
export default router